import React from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { simpleNotification } from "../../utils/notifications";

const PaypalButton = (props) => {
  const {
    amount,
    currency,
    paypalEmail,
    transactionId,
    isAuth = false,
    resultHandle,
    payNote,
  } = props;
  const getAuthToken = () => {
    return props?.auth?.token || "";
  };

  const buildRequestConfig = () => {
    const token = getAuthToken();
    const headers = token ? { Authorization: `JWT ${token}` } : {};
    return { headers, withCredentials: true };
  };
  const initialOptions = {
    //这里改成真实的paypal账号id
    clientId:
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
        ? "ARXGPRCtSatdJCa9iIN2bqalnDVa7cOwwqYqlmpzhIgI930i0Ur7ELQXadkhiRkew7CdbPJYljEoAX-b"
        : "AUBaMIFpsLzqfsEr7dicoeOlX8tq4tSTFLGEor2T2N8YTVTU9rHorEPCvpnWGBQ2TTal_Oxwd7HnHU2W",
    components: "buttons,hosted-fields",
    intent: isAuth ? "authorize" : "capture",
    currency: currency,
  };

  const styles = {
    shape: "sharp",
    layout: "vertical",
    // layout: 'horizontal',
    color: "blue",
    //shape: 'pill',
    label: "pay",
    // label: 'checkout',
    tagline: "false",
    size: "small",
    borderRadius: 10,
  };
  const onCancel = (data) => {
    // Show a cancel page, or return to cart
    //window.location.assign("/");
  };

  const onError = (err) => {
    console.error("PayPal error:", err);
    let errorMessage = "Paypal failure";
    if (err?.response?.data?.message) {
      const rawMessage = err.response.data.message;
      const jsonMatch = rawMessage.match(/{.*}/s);
      if (jsonMatch) {
        try {
          const errorData = JSON.parse(jsonMatch[0]);
          if (errorData?.error_description) {
            errorMessage = errorData.error_description;
          } else if (
            errorData?.details &&
            errorData.details.length > 0 &&
            errorData.details[0].description
          ) {
            errorMessage = errorData.details[0].description;
            if (errorMessage === "The merchant account is restricted.") {
              errorMessage =
                "The user's PayPal account is restricted. Please contact the user to check their PayPal account.";
            }
          }
        } catch (e) {
          console.error("JSON parse failure:", e, jsonMatch);
          errorMessage = rawMessage;
        }
      } else {
        errorMessage = rawMessage;
      }
      simpleNotification({
        level: "error",
        title: "Paypal failure",
        message: errorMessage,
      });
    } else if (err?.response?.data?.code) {
      if (err?.response?.data?.code === "E_USER_RECONCILIATION_INVALID") {
        simpleNotification({
          level: "error",
          title: "Paypal failure",
          message:
            "Currently, there is an anomaly in the payment data. Please refrain from making any payments until the issue has been fully resolved.",
        });
      }
    }
    //window.location.assign("/");
  };

  // 前端 createOrder 方法，向后端请求订单 ID，并传递给 PayPal SDK 进行支付
  const createOrder = async (data, actions) => {
    const orderData = {
      amount: amount, // 订单金额
      currency: currency, // 货币类型n
      payee: {
        email_address: paypalEmail, // 指定收款人PayPal账户（邮箱）
      },
      userid: "12344",
      transactionId: transactionId,
      email: "user@example.com",
      platform: "web",
      ip: "127.0.0.1",
      description: "支付描述", // 支付描述,
      isAuth: isAuth,
      custom: payNote(),
    };
    try {
      // 向后端发请求，创建 PayPal 订单并获取订单 ID 和其他信息
      //const { data: orderResponse } = await axios.post('/paypal/create-order', orderData);
      //const { data: orderResponse } = await axios.post('/paypal/withdrawal', orderData);
      const {
        data: orderResponse,
        status: orderStatus,
        code,
        message,
        statusText,
      } = await axios.post(
        "/api/v1/paypal/withdrawalC",
        { orderData: orderData },
        buildRequestConfig(),
      );
      if (!orderResponse) {
        console.error("create order failure:", code, message);
        return;
      }
      if (orderStatus !== 200) {
        console.error("create order:", orderStatus, statusText);
        return;
      }

      // 使用 PayPal SDK 创建订单
      /*return actions.order.create({
      purchase_units: [{
        amount: {
          value: orderData.amount.toString(),  // 订单金额
          currency_code: orderData.currency,   // 货币类型
          description: orderData.description,     // 支付描述
        },
      }],
      // 这里使用从后端获得的订单 ID,用于其它 PayPal SDK 操作的关联
      orderID: orderResponse.data.orderId
    });*/
      return orderResponse.data.orderId;
    } catch (error) {
      console.error("Error creating order:", error, error.response);
      onError(error);
      //return Promise.reject('Order creation failed');
    }
  };

  // 前端支付成功后的回调
  const onApprove = async (data, actions) => {
    try {
      //const order = await actions.order.capture();
      const {
        data: orderResponse,
        status: orderStatus,
        code,
        message,
        statusText,
      } = await axios.post(
        "/withdrawal/executeC",
        { orderId: data.orderID, PayerID: "-", isAuth: isAuth },
        buildRequestConfig(),
      );
      if (!orderResponse) {
        console.error("create order failure:", code, message);
        resultHandle("failure");
        return;
      }
      if (orderStatus !== 200) {
        console.error("create order:", orderStatus, statusText);
        resultHandle("failure");
        return;
      }
      resultHandle("success");
    } catch (error) {
      console.error("Error capturing order:", error);
      resultHandle("failure");
    }
  };

  return (
    <PayPalScriptProvider
      options={initialOptions}
      style={{ borderRadius: "100px" }}
    >
      <PayPalButtons
        style={styles}
        createOrder={createOrder}
        onApprove={onApprove}
        onCancel={onCancel}
        onError={onError}
        fundingSource="paypal" // 只允许显示 PayPal
        disableFunding="credit,card" // 禁用 Credit 和 Card 支付方式（如果需要）
      />
    </PayPalScriptProvider>
  );
};

export default PaypalButton;



